application.register("lib-parallax", class extends Stimulus.Controller {
    connect() {

        this.element.classList.add("parallax");

        this.element.querySelector("img").addEventListener("load",()=>{
            this.updateParallax(true);
        }, false);

        this.element.querySelector("img").dispatchEvent(new Event('load', {'bubbles': true}));

        window.addEventListener('scroll', ()=>{
            this.updateParallax(false);
        }, false);

        window.addEventListener('resize', ()=>{
            this.updateParallax(false);
        }, false);
    }

    disconnect() {
        this.element.querySelector("img").removeEventListener("load",()=>{
            this.updateParallax(true);
        }, false);

        window.removeEventListener('scroll', ()=>{
            this.updateParallax(false);
        }, false);

        window.removeEventListener('resize', ()=>{
            this.updateParallax(false);
        }, false);
    }

    updateParallax(initial) {
        let container_height;
        if(window.innerWidth < 600) {
            container_height = (this.element.getBoundingClientRect().height > 0) ? this.element.getBoundingClientRect().height : this.element.querySelector("img").getBoundingClientRect().height;
        }
        else {
            container_height = (this.element.getBoundingClientRect().height > 0) ? this.element.getBoundingClientRect().height : 500;
        }

        let img = this.element.querySelector("img");
        let img_height = img.getBoundingClientRect().height;
        let parallax_dist = img_height - container_height;
        let top = this.element.getBoundingClientRect().top;
        let bottom = top + container_height;
        let scrollTop = window.scrollY;
        let windowHeight = window.innerHeight;
        let windowBottom = scrollTop + windowHeight;
        let percentScrolled = (windowBottom - top) / (container_height + windowHeight);
        let parallax = Math.round((parallax_dist * percentScrolled));

        if (initial) {
            img.style.display = "block";
        }
        if ((bottom > scrollTop) && (top < (scrollTop + windowHeight))) {
            img.style.transform = "translate3D(-50%," + parallax + "px, 0)";
        }
    }
});